import { reactive, inject, InjectionKey, provide } from '@vue/composition-api'

export type Moment = any

export interface MomentsState {
  moments: Array<Moment>
  momentInFocus: Moment
}

export const MomentsStateKey: InjectionKey<MomentsState> = Symbol(
  'momentsState'
)
export const momentsState = () =>
  reactive({
    moments: [],
    momentInFocus: null
  })

export const useMomentsState = () => inject(MomentsStateKey)
export const provideMomentsState = () =>
  provide(MomentsStateKey, momentsState())

export const getMomentById = (momentsState: MomentsState, id: number) =>
  momentsState.moments.find(moment => moment.id == id)

export const momentChanged = (
  momentsState: MomentsState,
  moment: unknown,
  operation: string,
  id: number
) => {
  const index = momentsState.moments.findIndex(m => m.id == id)
  if (operation == 'save')
    momentsState.moments = [
      ...momentsState.moments.slice(0, index),
      moment,
      ...momentsState.moments.slice(index + 1)
    ]
  else if (operation == 'delete')
    momentsState.moments = [
      ...momentsState.moments.slice(0, index),
      ...momentsState.moments.slice(index + 1)
    ]
  else if (operation == 'create')
    momentsState.moments = [...momentsState.moments, moment]
  else throw new Error(`Moments operation unknown: '${operation}'`)
}
